export interface ChatSidebarTimeOptions {
  translate?: (key: string) => string;
  hour12?: boolean;
}

export default function chatSidebarTime(
  utcTime: string | number | Date,
  options?: ChatSidebarTimeOptions
): string {
  const utcDate = new Date(utcTime);
  const now = new Date();
  const translate = options?.translate ?? ((k: string) => k);
  const hour12 = options?.hour12 ?? false;

  if (
    utcDate.getUTCFullYear() === now.getUTCFullYear() &&
    utcDate.getUTCMonth() === now.getUTCMonth() &&
    utcDate.getUTCDate() === now.getUTCDate()
  ) {
    const formatOptions: Intl.DateTimeFormatOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12,
    };
    return new Intl.DateTimeFormat(
      hour12 ? "en-US" : "ru-RU",
      formatOptions
    ).format(utcDate);
  } else {
    now.setDate(now.getDate() - 1);
    if (
      utcDate.getUTCFullYear() === now.getUTCFullYear() &&
      utcDate.getUTCMonth() === now.getUTCMonth() &&
      utcDate.getUTCDate() === now.getUTCDate()
    ) {
      return translate("Yesterday");
    } else {
      const dd = String(utcDate.getUTCDate()).padStart(2, "0");
      const mm = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
      const yyyy = utcDate.getUTCFullYear();
      return `${dd}/${mm}/${yyyy}`;
    }
  }
}
